import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { Box, Grid } from '@yonderland/andes-react';
import { getImageSourceSetByProductCode } from '../../util/ImageUtil';
export const PromoBasketPopupPreview = ({ image, productCode }) => {
    const { productImageConfig } = useAemConfig();
    const imageUrl = getImageSourceSetByProductCode(productCode, image, productImageConfig)[ProductImageSizesPortraitEnum.basket];
    return (_jsx(Grid, { columns: 12, children: _jsx(Grid.Cell, { span: { xs: 5, md: 12 }, children: _jsx(Box, { paddingBlockEnd: "1", paddingInlineEnd: { md: '4' }, children: _jsx(Image, { src: imageUrl, alt: productCode, lazy: true }) }) }) }));
};
